import { createRouter, createWebHistory } from "vue-router";
import { defaultTitle } from "../assets/scripts/config";
import List from "../views/UnitList.vue";
import UnitTitlesJson from "@/assets/json/unit_titles.json";
import LearningUnit01 from "../assets/json/learning_unit_01.json";
import LearningUnit02 from "../assets/json/learning_unit_02.json";
import LearningUnit03 from "../assets/json/learning_unit_03.json";
import LearningUnit04 from "../assets/json/learning_unit_04.json";
import LearningUnit05 from "../assets/json/learning_unit_05.json";
import LearningUnit06 from "../assets/json/learning_unit_06.json";
import LearningUnit07 from "../assets/json/learning_unit_07.json";
import LearningUnit08 from "../assets/json/learning_unit_08.json";
import LearningUnit09 from "../assets/json/learning_unit_09.json";
import LearningUnit10 from "../assets/json/learning_unit_10.json";
import LearningUnit11 from "../assets/json/learning_unit_11.json";
import LearningUnit12 from "../assets/json/learning_unit_12.json";
import LearningUnit13 from "../assets/json/learning_unit_13.json";
import LearningUnit14 from "../assets/json/learning_unit_14.json";
import LearningUnit15 from "../assets/json/learning_unit_15.json";
import LearningUnit16 from "../assets/json/learning_unit_16.json";
import store from "@/store/index.js";

const { unit_titles } = UnitTitlesJson;


const routes = [
  {
    path: "/",
    name: "List",
    component: List,
    meta: { title: "NEW HORIZON Elementary 5ホーム" },
    props: {
      unitTitlesJson: UnitTitlesJson,
    },
  },
  {
    path: "/a/",
    name: "a",
    component: () =>
      import(/* webpackChunkName: "A" */ "../views/LearningUnit.vue"),
    meta: { title: "Digital Dictionary" },
    props: {
      unitTitle: unit_titles[0].title,
      learningUnitJson: LearningUnit01,
    },
  },
  {
    path: "/b/",
    name: "b",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Digital Map" },
    props: {
      unitTitle: unit_titles[1].title,
      learningUnitJson: LearningUnit02,
    },
  },
  {
    path: "/c/",
    name: "c",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "アルファベット" },
    props: {
      unitTitle: unit_titles[2].title,
      learningUnitJson: LearningUnit03,
    },
  },
  {
    path: "/d/",
    name: "d",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Let's start!" },
    props: {
      unitTitle: unit_titles[3].title,
      learningUnitJson: LearningUnit04,
    },
  },
  {
    path: "/e/",
    name: "e",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Unit 1" },
    props: {
      unitTitle: unit_titles[4].title,
      learningUnitJson: LearningUnit05,
    },
  },
  {
    path: "/f/",
    name: "f",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Unit 2" },
    props: {
      unitTitle: unit_titles[5].title,
      learningUnitJson: LearningUnit06,
    },
  },
  {
    path: "/g/",
    name: "g",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Unit 3" },
    props: {
      unitTitle: unit_titles[6].title,
      learningUnitJson: LearningUnit07,
    },
  },
  {
    path: "/h/",
    name: "h",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Check Your Steps 1" },
    props: {
      unitTitle: unit_titles[7].title,
      learningUnitJson: LearningUnit08,
    },
  },
  {
    path: "/i/",
    name: "i",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Unit 4" },
    props: {
      unitTitle: unit_titles[8].title,
      learningUnitJson: LearningUnit09,
    },
  },
  {
    path: "/j/",
    name: "j",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Unit 5" },
    props: {
      unitTitle: unit_titles[9].title,
      learningUnitJson: LearningUnit10,
    },
  },
  {
    path: "/k/",
    name: "k",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Unit 6" },
    props: {
      unitTitle: unit_titles[10].title,
      learningUnitJson: LearningUnit11,
    },
  },
  {
    path: "/l/",
    name: "l",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Check Your Steps 2" },
    props: {
      unitTitle: unit_titles[11].title,
      learningUnitJson: LearningUnit12,
    },
  },
  {
    path: "/m/",
    name: "m",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Unit 7" },
    props: {
      unitTitle: unit_titles[12].title,
      learningUnitJson: LearningUnit13,
    },
  },
  {
    path: "/n/",
    name: "n",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Unit 8" },
    props: {
      unitTitle: unit_titles[13].title,
      learningUnitJson: LearningUnit14,
    },
  },
  {
    path: "/o/",
    name: "o",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Check Your Steps 3" },
    props: {
      unitTitle: unit_titles[14].title,
      learningUnitJson: LearningUnit15,
    },
  },
  {
    path: "/p/",
    name: "p",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Try it!" },
    props: {
      unitTitle: unit_titles[15].title,
      learningUnitJson: LearningUnit16,
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.afterEach((to) => {
  document.title = to.meta.title || defaultTitle;
});

router.beforeEach(() =>{
  store.commit(
    "toggleDarkMode",
    localStorage.getItem("darkModeFrag") === "true"
  );
});

export default router;
